import { SelectField } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { apiClient } from '../../../../api/index';

type Props = {
  stationId: string;
  label: string;
  name: string;
  multiple?: boolean;
  markRequired?: boolean;
};

export const MentionSelect = ({ stationId, label, name, multiple = true, markRequired }: Props) => {
  const { $t } = useIntl();

  return (
    <SelectField
      label={label}
      name={name}
      placeholder={$t({
        id: 'audit.scheduleStatusScreen.filter.idPlaceholder',
        defaultMessage: 'Todos',
      })}
      options={[] as { name: string }[]}
      getOptionValue={(m: { name: string }) => m.name}
      getOptionLabel={(m: { name: string }) => m.name}
      loadOptions={async (name) => {
        const { results } = await apiClient.audit.fetchMatchesByCustomId({
          stationId,
          select: ['id', 'name'],
          filter: {
            nameLike: `%${name}%`,
          },
        });

        const uniqueNamesMap = new Map<string, string>();

        results.forEach((result) => {
          if (!uniqueNamesMap.has(result.name)) {
            uniqueNamesMap.set(result.name, result.id);
          }
        });

        const uniqueNamesArray = Array.from(uniqueNamesMap).map(([name, id]) => ({ id, name }));

        return uniqueNamesArray;
      }}
      multiple={multiple}
      markRequired={markRequired}
    />
  );
};
